import { useAuthorization } from 'components/Authorization';

export function isOUPayload(payload: Oversea.Token.Payload | null) {
  const { leyan_user, name, nimToken } = payload || {};

  if (import.meta.env.VITE_ENV === 'staging' || import.meta.env.VITE_ENV === 'feature') {
    return nimToken?.startsWith('fakeNimToken');
  }

  const isOU = Boolean(leyan_user && !leyan_user.userType && name === 'OU');

  return isOU;
}

function useIsOU() {
  const { payload } = useAuthorization<Oversea.Token.Payload>();

  return isOUPayload(payload);
}

export default useIsOU;
